import { COUNTING_METHOD } from '@interfaces/machines';
import { DATE_TIME_FORMAT_DISPLAY, injectConditionalArrayItems, localTime } from '@helpers';
import i18n from 'i18n-js';
import { CredentialSection, MachineCredential, MachineProperty, MachinePropertiesMap } from './types';

export const convertTimeToString = (date: string) => {
  if (!date) {
    return '';
  }
  return localTime(date).format(DATE_TIME_FORMAT_DISPLAY);
};

export const getMachineCountingMethodLabel = (countingMethod: COUNTING_METHOD): string => {
  const config = {
    [COUNTING_METHOD.LOGICAL]: 'Logical Part Counter',
    [COUNTING_METHOD.MACHINE_COUNTER]: 'Machine Part Counter',
    [COUNTING_METHOD.MACHINE_CONTROL_EVENT]: 'Machine Part Counter',
    [COUNTING_METHOD.MACHINE_PART_COUNT]: 'Machine Part Counter',
  };

  return config[countingMethod] || '';
};

export const buildMachinePropertiesMap = (machineProperties?: MachineProperty[]): MachinePropertiesMap => {
  const propertiesMap = machineProperties?.reduce<Record<string, string>>((acc, prop) => {
    acc[prop.propertyKey] = prop.propertyValue;
    return acc;
  }, {});

  return {
    folder: propertiesMap?.SendNcFileDefaultFolder,
    machineModel: propertiesMap?.MachineModel,
    controlMachineType: propertiesMap?.ControlMachineType,
    controlSoftwareVersion: propertiesMap?.ControlSoftwareVersion,
    controlSerialNumber: propertiesMap?.ControlSerialNumber,
    controlBrand: propertiesMap?.ControlBrand,
    controlType: propertiesMap?.ControlType,
  };
};

export const buildCredentialsData = (machineCredentials?: MachineCredential[], folder?: string): CredentialSection[] => {
  if (!machineCredentials?.length) {
    return [];
  }

  return machineCredentials.map((item) => {
    const isCredentialsForFileTransfer = item.credentialType === 'CredentialForFileTransfer';
    const label = isCredentialsForFileTransfer ? 'MACHINE FILE ACCESS' : 'MACHINE ACTIVITY CREDENTIALS';

    return {
      label,
      details: [
        {
          value: item?.userName,
          name: i18n.t('User Name'),
          noArrow: true,
          hideArrow: true,
        },
        {
          value: String(item?.password).replace(/./g, '*'),
          name: i18n.t('Password'),
          secure: true,
          noArrow: true,
          hideArrow: true,
        },
        ...injectConditionalArrayItems(isCredentialsForFileTransfer, {
          value: folder,
          name: i18n.t('Folder'),
          secure: true,
          noArrow: true,
          hideArrow: true,
        }),
      ],
    };
  });
};

export const buildFilterExceptionList = (connectionMethodCode?: string) => {
  const isFanuc = connectionMethodCode === 'focas';
  if (!isFanuc) return [];

  return [
    {
      details: [{ value: '', name: i18n.t('Filter Exception List'), onClick: () => console.log('Filter Exception List') }],
    },
  ];
};
